import { globalStyles } from '@ctw/shared/content/document-viewer/_internal/renderers/pdf/pdf-cda-renderer';
import type { CdaSection } from '@ctw/shared/utils/cda/types';
import { uniqueIdentifierHash } from '@ctw/shared/utils/hash';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { memo } from 'react';
import { headingStyles } from './pdf-heading-renderer';
import { PdfHtmlRenderer } from './pdf-html-renderer';

const styles = StyleSheet.create({
  section: {
    fontWeight: 400,
    flexDirection: 'column',
    gap: 5,
  },
});

interface PdfSectionRendererProps {
  cdaSection: CdaSection;
  disableBreak?: boolean;
}

export const PdfSectionRenderer = memo(({ cdaSection, disableBreak }: PdfSectionRendererProps) => {
  return cdaSection.id && cdaSection.title ? (
    <View style={styles.section} break={!disableBreak}>
      <Text style={[headingStyles.h2]}>
        {cdaSection.index + 1}. {cdaSection.title}
      </Text>
      {cdaSection.parseError && (
        <View style={globalStyles.alertBox}>
          <Text style={globalStyles.alertText}>
            This section could not be displayed due to invalid document XML.
          </Text>
        </View>
      )}
      {cdaSection.parsedHtmlNodes.length > 0 && (
        <PdfHtmlRenderer
          id={`${cdaSection.id}-html|${uniqueIdentifierHash(cdaSection.parsedHtmlNodes)}`}
          parsedHtmlNodes={cdaSection.parsedHtmlNodes}
          emptyState={
            <View style={globalStyles.alertBox}>
              <Text style={globalStyles.alertText}>
                There is no content available for this section of the document.
              </Text>
            </View>
          }
        />
      )}
    </View>
  ) : null;
});
